import { http } from '../utils/axios';
import { IPaymentMethod } from '../interfaces/payment-method.interface';
import {
  TStripeIntent,
  TAddPaymentMethodAction,
  TSetupIntentAction,
  TGetAvailablePaymentMethodsAction,
  TGetPaymentMethodAction
} from '../types';
import { IPaymentProcessorKeys } from 'shared/interfaces/payment-processor-keys.interface';

class BillingsService {
  private static instance: BillingsService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): BillingsService {
    if (!BillingsService.instance) {
      BillingsService.instance = new BillingsService();
    }

    return BillingsService.instance;
  }

  getPaymentMethodData = async (payload: TGetPaymentMethodAction) => {
    const { data } = await http<IPaymentMethod>({
      url: `/billingDetails/actions/getPaymentMethod/${payload.id}`,
      method: 'GET',
      params: payload
    });

    return data;
  };

  createSetupIntent = async (payload: TSetupIntentAction = {}) => {
    const { data } = await http<TStripeIntent>({
      url: '/billingDetails/actions/stripe/setupIntent',
      method: 'POST',
      data: payload
    });

    return data;
  };

  addPaymentMethod = async (payload: TAddPaymentMethodAction) => {
    const { data } = await http<IPaymentMethod>({
      url: '/billingDetails/actions/attachPaymentMethod',
      method: 'POST',
      data: payload
    });

    return data;
  };

  removePaymentMethod = async (payload: {
    paymentMethodId: string;
    patientId: string;
  }) => {
    const { data } = await http<{ paymentMethodId: string }>({
      url: '/billingDetails/actions/removeCard',
      method: 'DELETE',
      data: payload
    });

    return data.paymentMethodId;
  };

  getAvailablePaymentMethods = async (
    payload: TGetAvailablePaymentMethodsAction
  ) => {
    const { data } = await http<IPaymentMethod[]>({
      url: '/billingDetails/actions/getAvailablePaymentMethods',
      method: 'GET',
      params: payload
    });

    return data;
  };

  getAffiliatePaymentProcessorsKeys = async () => {
    const { data } = await http<IPaymentProcessorKeys>({
      url: '/billingDetails/actions/paymentProcessor',
      method: 'GET'
    });

    return data;
  };
  updateAffiliatePaymentProcessorsKeys = async (payload) => {
    const { data } = await http<IPaymentProcessorKeys>({
      url: '/billingDetails/actions/paymentProcessor',
      method: 'PUT',
      data: payload
    });

    return data;
  };
}

const instance = BillingsService.getInstance();

export default instance;
